module.exports = __webpack_public_path__ + "static/media/jfif.e6ab4004.svg";